import gql from 'graphql-tag';

const SEND_NOTIFICATION = gql`
    mutation sendNotification ($input: NotificationInput) {
        sendNotification (input: $input) {
            message,
            status,
            data
        }
    }
`;

export default SEND_NOTIFICATION;
